import { useSettings } from '@/contexts/SettingsContext';

/**
 * Get cost type options from settings
 */
export function useCostTypeOptions() {
    const { settings } = useSettings();

    // Leads and projects share one cost-type vocabulary.
    const costTypes = settings.costLineTypes || [];

    return costTypes.map((type) => {
        const normalizedValue = type.toLowerCase().replace(/\s+/g, '_');
        return {
            value: normalizedValue,
            label: type,
        };
    });
}
